<template>
  <div
    class="card-shadow flex h-[440px] w-auto flex-col justify-between rounded border border-steel-200 md:w-full"
  >
    <div
      v-if="displayConnectedInsurance"
      class="flex items-center gap-1 rounded-t-sm border-b border-steel-200 bg-steel-100 px-4 py-1"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.73534 2.53267C6.01664 2.20815 6.36448 1.94797 6.75525 1.76979C7.14601 1.5916 7.57053 1.49959 8 1.5C8.90467 1.5 9.71534 1.9 10.2647 2.53267C10.6931 2.50207 11.1232 2.56406 11.5255 2.7144C11.9279 2.86475 12.2932 3.09994 12.5967 3.404C12.9006 3.70738 13.1357 4.07258 13.2861 4.47484C13.4364 4.87709 13.4985 5.30698 13.468 5.73533C13.7924 6.0167 14.0525 6.36457 14.2305 6.75533C14.4086 7.14609 14.5005 7.57058 14.5 8C14.5004 8.42947 14.4084 8.854 14.2302 9.24476C14.052 9.63552 13.7919 9.98336 13.4673 10.2647C13.4978 10.693 13.4357 11.1229 13.2854 11.5252C13.1351 11.9274 12.8999 12.2926 12.596 12.596C12.2926 12.8999 11.9274 13.1351 11.5252 13.2854C11.1229 13.4357 10.693 13.4978 10.2647 13.4673C9.98336 13.7919 9.63552 14.052 9.24476 14.2302C8.854 14.4084 8.42947 14.5004 8 14.5C7.57053 14.5004 7.14601 14.4084 6.75525 14.2302C6.36448 14.052 6.01664 13.7919 5.73534 13.4673C5.30692 13.498 4.87692 13.4361 4.47454 13.2859C4.07216 13.1357 3.70682 12.9006 3.40334 12.5967C3.09931 12.2932 2.86415 11.9279 2.7138 11.5255C2.56346 11.1231 2.50145 10.6931 2.532 10.2647C2.20761 9.9833 1.94755 9.63543 1.76949 9.24467C1.59142 8.85391 1.49951 8.42942 1.5 8C1.5 7.09534 1.9 6.28467 2.53267 5.73533C2.50217 5.30698 2.5642 4.87708 2.71455 4.47482C2.86489 4.07255 3.10003 3.70735 3.404 3.404C3.70735 3.10003 4.07255 2.86489 4.47482 2.71455C4.87708 2.5642 5.30698 2.50217 5.73534 2.53267ZM10.4067 6.79067C10.4467 6.73737 10.4756 6.67661 10.4918 6.61197C10.508 6.54732 10.5111 6.4801 10.5009 6.41424C10.4907 6.34838 10.4675 6.28522 10.4326 6.22847C10.3976 6.17171 10.3517 6.12252 10.2975 6.08377C10.2433 6.04502 10.1819 6.0175 10.1169 6.00282C10.0519 5.98814 9.98459 5.98661 9.91899 5.99831C9.85338 6.01001 9.79078 6.0347 9.73485 6.07094C9.67893 6.10718 9.63081 6.15423 9.59334 6.20933L7.436 9.22933L6.35334 8.14667C6.25855 8.05835 6.13319 8.01027 6.00365 8.01255C5.87412 8.01484 5.75053 8.06731 5.65892 8.15892C5.56731 8.25053 5.51484 8.37412 5.51255 8.50365C5.51027 8.63319 5.55835 8.75855 5.64667 8.85333L7.14667 10.3533C7.198 10.4046 7.25987 10.4441 7.32799 10.4691C7.39612 10.4941 7.46886 10.5039 7.54118 10.498C7.61349 10.492 7.68364 10.4704 7.74675 10.4346C7.80987 10.3988 7.86444 10.3497 7.90667 10.2907L10.4067 6.79067Z"
          fill="#39B15B"
        />
      </svg>
      <p class="text-xs text-steel-900">Connected Insurance</p>
      <Popper
        placement="top"
        :hover="true"
        offset-distance="6"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M6.5625 4.08335C6.40141 4.08335 6.27083 4.21394 6.27083 4.37502V4.95835C6.27083 5.11944 6.40141 5.25002 6.5625 5.25002H7.4375C7.59858 5.25002 7.72916 5.11944 7.72916 4.95835V4.37502C7.72916 4.21394 7.59858 4.08335 7.4375 4.08335H6.5625Z"
            fill="#374053"
          />
          <path
            d="M6.5625 6.41669C6.40141 6.41669 6.27083 6.54727 6.27083 6.70835V9.62502C6.27083 9.7861 6.40141 9.91669 6.5625 9.91669H7.4375C7.59858 9.91669 7.72916 9.7861 7.72916 9.62502V6.70835C7.72916 6.54727 7.59858 6.41669 7.4375 6.41669H6.5625Z"
            fill="#374053"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.8333 7.00002C12.8333 10.2217 10.2217 12.8334 7 12.8334C3.77834 12.8334 1.16666 10.2217 1.16666 7.00002C1.16666 3.77836 3.77834 1.16669 7 1.16669C10.2217 1.16669 12.8333 3.77836 12.8333 7.00002ZM11.375 7.00002C11.375 9.41627 9.41624 11.375 7 11.375C4.58375 11.375 2.625 9.41627 2.625 7.00002C2.625 4.58377 4.58375 2.62502 7 2.62502C9.41624 2.62502 11.375 4.58377 11.375 7.00002Z"
            fill="#374053"
          />
        </svg>
        <template #content>
          <div
            class="max-w-56 rounded-md bg-dark-gray px-2 py-1 text-left text-2xs text-white"
          >
            <p>
              Highway enables up-to-date policy records to help ensure
              compliance requirements are continuously verified.
            </p>
          </div>
        </template>
      </Popper>
    </div>
    <div
      class="flex h-[380px] flex-col gap-2 overflow-y-auto rounded px-4 pb-4 md:w-full"
    >
      <div class="flex flex-row justify-between pt-4">
        <div class="flex flex-col">
          <h1 class="text-neutral-1100 text-lg font-medium">
            {{ insurance_types[policy?.is_type] }}
          </h1>
          <section v-if="displayAdditionalInsuredBadge">
            <p
              v-if="subheading"
              class="mb-1 whitespace-nowrap text-xs font-normal uppercase text-steel-800"
            >
              {{ subheading }}
            </p>
            <div
              v-if="policy.has_additional_insured"
              class="inline-flex cursor-pointer items-center justify-center gap-0.5 self-start rounded-full bg-ocean-100 px-1 py-0.5 text-xs"
            >
              <img
                src="@/assets/blue-checkmark.svg"
                alt="blue checkmark"
              />
              <p
                class="font-medium text-ocean-800"
                style="font-size: 11px"
              >
                Additional Insured
              </p>
            </div>
          </section>
        </div>
        <div
          class="flex h-6 items-center justify-center gap-1 rounded-full px-2 py-0.5"
          :class="
            getPolicyStyle.fontColor + ' ' + getPolicyStyle.backgroundColor
          "
        >
          <span class="whitespace-nowrap text-sm font-medium">
            {{ getPolicyStatus(policy.status) }}
          </span>

          <Popper
            v-if="policy.status === 'pending_cancellation'"
            placement="top"
            :hover="true"
            :arrow="true"
            offset-distance="6"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
            >
              <path
                d="M8.40031 1.33337C12.0821 1.33355 15.0663 4.31858 15.0663 8.00037C15.0662 11.682 12.082 14.6662 8.40031 14.6664C4.71852 14.6664 1.7335 11.6821 1.73332 8.00037C1.73332 4.31847 4.71842 1.33337 8.40031 1.33337ZM8.09953 10.5883C7.91334 10.5883 7.82017 10.5882 7.74895 10.6244C7.68632 10.6563 7.63541 10.7073 7.60344 10.7699C7.56711 10.8412 7.56633 10.9348 7.56633 11.1215V11.3881C7.56633 11.5747 7.56711 11.6683 7.60344 11.7396C7.63541 11.8022 7.68636 11.8532 7.74895 11.8851C7.82016 11.9213 7.91339 11.9213 8.09953 11.9213H8.70012C8.88672 11.9213 8.98039 11.9215 9.05168 11.8851C9.11425 11.8532 9.16527 11.8022 9.19719 11.7396C9.23352 11.6683 9.23332 11.5747 9.23332 11.3881V11.1215C9.23332 10.9348 9.23352 10.8412 9.19719 10.7699C9.16528 10.7073 9.11426 10.6564 9.05168 10.6244C8.98039 10.5881 8.88672 10.5883 8.70012 10.5883H8.09953ZM10.1454 5.8822C9.64984 4.89102 8.5696 4.49184 7.6259 4.73767C6.75861 4.96372 6.10685 5.68406 5.94133 6.72302C5.91659 6.87839 5.90426 6.95669 5.93547 7.03943C5.96044 7.10514 6.02098 7.1765 6.08195 7.2113C6.15867 7.25491 6.25061 7.25427 6.43352 7.25427H7.03313C7.19706 7.25427 7.27943 7.25485 7.33586 7.23376C7.4017 7.20916 7.41849 7.19701 7.46574 7.1449C7.50617 7.10021 7.55542 6.97752 7.65324 6.73181C7.6805 6.66335 7.71165 6.60862 7.74211 6.5658C7.82765 6.44572 7.93546 6.37881 8.04582 6.34998C8.28173 6.28852 8.53513 6.38939 8.65422 6.62732C8.73626 6.79139 8.73076 6.8855 8.71281 6.96326C8.68637 7.07772 8.61516 7.22204 8.45695 7.45935C8.42588 7.50596 8.38821 7.55962 8.34758 7.61853C8.216 7.80928 8.04614 8.05543 7.91594 8.29724C7.7977 8.51687 7.68876 8.77064 7.62492 9.05896C7.5935 9.20089 7.57782 9.2719 7.60637 9.35876C7.62843 9.42561 7.69235 9.50539 7.75285 9.54138C7.83147 9.58799 7.92095 9.58826 8.09953 9.58826H8.705C8.88029 9.58826 8.96814 9.58806 9.01848 9.57166C9.08776 9.54907 9.09262 9.54586 9.14543 9.49548C9.18382 9.45843 9.25063 9.33444 9.38371 9.08728C9.46719 8.93224 9.55834 8.8001 9.67278 8.63416C9.72438 8.55932 9.78105 8.47712 9.84367 8.38318C10.0186 8.1207 10.2383 7.76504 10.3368 7.33826C10.4439 6.8744 10.3967 6.38474 10.1454 5.8822Z"
                fill="#F6F7F9"
              />
            </svg>
            <template #content>
              <div
                class="w-72 rounded-md bg-dark-gray px-2 py-1 text-left text-2xs text-light-gray"
              >
                <p class="text-xs">
                  Policies that are pending cancellation indicate the insurance
                  company or financial institution who made the initial filing
                  of the motor carrier's BIPD coverage to the FMCSA’s Licensing
                  and Insurance division has submitted a notice of cancellation
                  to the FMCSA, which is most commonly caused by a missed
                  payment.
                </p>
                <p class="mt-2 text-xs">
                  The notice will remain in place until the cancellation date
                  occurs or the notice is rescinded because a payment is made.
                  The BIPD coverage does remain in effect during this period,
                  but Highway flags the motor carrier's other policies with the
                  same notice because the status of those coverages is unknown.
                  Please contact Highway should you require investigation into
                  the status of those policy coverages today.
                </p>
              </div>
            </template>
          </Popper>
        </div>
      </div>
      <div class="flex flex-col gap-0.5">
        <span class="text-xs font-medium text-steel-800">Insurer Name</span>
        <p class="text-neutral-1100 text-xs font-medium">
          {{ formatTitleCase(policy?.insurance_insurer?.name) }}
        </p>
        <span
          v-if="
            displayAMBestRating &&
            policy?.insurance_insurer?.am_best?.am_best_alpha_rating
          "
          class="font-normal text-steel-1100"
          style="font-size: 11px"
        >
          AM Best Rating:
          {{ policy?.insurance_insurer?.am_best?.am_best_alpha_rating }}
        </span>
      </div>
      <span class="border-b border-steel-200"></span>
      <div class="flex justify-start gap-12">
        <div class="flex flex-col gap-0.5">
          <span class="text-xs font-medium text-steel-800">Policy Number</span>
          <span class="text-neutral-1100 text-xs font-medium">
            {{ formatPolicy(policy?.number) }}
          </span>
        </div>
      </div>
      <span class="border-b border-steel-200"></span>

      <div class="flex flex-col gap-6">
        <div class="align-items flex justify-between">
          <div class="flex w-[200px] flex-col gap-0.5">
            <span class="text-xs font-medium text-steel-800">
              Effective Date
            </span>
            <span class="text-neutral-1100 text-xs font-medium">
              {{ calculateExpirationDate(policy?.effective_date || null) }}
            </span>
          </div>
          <span class="mx-4 my-1 border-l border-steel-200"></span>
          <div class="flex w-full flex-col gap-0.5">
            <span class="text-xs font-medium text-steel-800">
              Expiration Date
            </span>
            <span
              class="text-xs font-medium"
              :class="
                isExpirationWithin7Days ? 'text-rose-800' : 'text-neutral-1100'
              "
            >
              {{ calculateExpirationDate(policy?.expiration_date || null) }}
            </span>
          </div>
        </div>
      </div>
      <span class="border-b border-steel-200"></span>
      <div
        v-if="policy?.cancellation_date"
        class="flex flex-col"
      >
        <div class="flex items-center gap-0.5">
          <span class="text-xs font-medium text-steel-800">
            Cancellation Date
          </span>
          <div style="margin-top: 1px">
            <Popper
              placement="top"
              :hover="true"
              :arrow="true"
              offset-distance="6"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="14"
                viewBox="0 0 15 14"
                fill="none"
              >
                <path
                  d="M7.39967 1.16663C10.6212 1.16663 13.2335 3.77812 13.2337 6.99963C13.2337 10.2213 10.6213 12.8336 7.39967 12.8336C4.17816 12.8334 1.56667 10.2212 1.56667 6.99963C1.56684 3.77823 4.17827 1.1668 7.39967 1.16663ZM7.13795 9.26428C6.97471 9.26428 6.89271 9.26478 6.83034 9.29651C6.77551 9.32444 6.73038 9.36866 6.70241 9.42346C6.67063 9.48584 6.67116 9.5678 6.67116 9.73108V9.96448C6.67116 10.1278 6.67062 10.2097 6.70241 10.2721C6.73037 10.327 6.77547 10.3711 6.83034 10.399C6.89272 10.4308 6.97466 10.4313 7.13795 10.4313H7.66237C7.82572 10.4313 7.9076 10.4308 7.96999 10.399C8.02467 10.3711 8.069 10.3268 8.09694 10.2721C8.12873 10.2097 8.12917 10.1278 8.12917 9.96448V9.73108C8.12917 9.5678 8.12872 9.48584 8.09694 9.42346C8.06899 9.36882 8.02466 9.3244 7.96999 9.29651C7.9076 9.26472 7.82572 9.26428 7.66237 9.26428H7.13795ZM8.92702 5.14709C8.49339 4.27983 7.54863 3.93008 6.72292 4.14514C5.96395 4.34285 5.39318 4.97333 5.24831 5.88245C5.22668 6.01828 5.2162 6.08649 5.24342 6.15881C5.26513 6.21636 5.31793 6.27863 5.37135 6.3092C5.43853 6.34754 5.51878 6.34827 5.67897 6.34827H6.20436C6.34767 6.34827 6.41966 6.34815 6.46901 6.32971C6.52637 6.30827 6.54128 6.29775 6.58229 6.25256C6.61768 6.21353 6.66071 6.10538 6.74635 5.89026C6.77026 5.83021 6.79777 5.78226 6.82448 5.74475C6.89932 5.63968 6.99354 5.5815 7.0901 5.55627C7.29658 5.50249 7.51817 5.59111 7.62233 5.79944C7.69387 5.94261 7.68971 6.02447 7.67409 6.09241C7.65097 6.19258 7.58797 6.31924 7.44948 6.52698C7.42238 6.56762 7.39014 6.61434 7.35475 6.66565C7.23959 6.8326 7.09082 7.04867 6.97682 7.26038C6.8734 7.45249 6.77779 7.67423 6.72194 7.92639C6.69443 8.05064 6.68032 8.11304 6.70534 8.18909C6.72461 8.24749 6.78041 8.31671 6.83327 8.34827C6.90218 8.38926 6.9812 8.38928 7.13795 8.38928H7.66725C7.81991 8.38928 7.89661 8.38982 7.94069 8.37561C8.00142 8.35582 8.00585 8.35324 8.05202 8.3092C8.08554 8.27723 8.14421 8.16869 8.261 7.95178C8.33405 7.81612 8.4138 7.7005 8.51393 7.5553C8.55911 7.48978 8.6085 7.41783 8.66335 7.33557C8.8165 7.10583 9.00876 6.79418 9.09499 6.42053C9.1886 6.01472 9.14679 5.58674 8.92702 5.14709Z"
                  fill="#6C7C9D"
                />
              </svg>
              <template #content>
                <div
                  class="w-auto rounded-md bg-dark-gray px-2 py-1 text-left text-2xs text-light-gray"
                >
                  <div v-if="policy.status === 'inactive'">
                    A cancellation notice has been provided or loss of coverage
                    has been detected.
                  </div>
                  <div v-else>
                    A notice has been provided stating the policy may be
                    cancelled on this date.
                  </div>
                </div>
              </template>
            </Popper>
          </div>
        </div>
        <span class="text-neutral-1100 -mt-1 text-xs font-medium">
          {{ calculateExpirationDate(policy?.cancellation_date || null) }}
        </span>
      </div>
      <span
        v-if="policy?.cancellation_date"
        class="border-b border-steel-200"
      ></span>

      <div class="flex flex-col gap-6">
        <div class="flex gap-2">
          <div
            v-if="
              policy.is_type !== 'commercial_general_liability' &&
              policy.is_type !== 'umbrella_liability' &&
              policy.is_type !== 'excess_liability' &&
              policy.is_type !== 'employers_liability'
            "
            class="flex flex-col gap-0.5"
          >
            <span class="text-xs font-medium text-steel-800">Limit</span>
            <span
              v-if="!isWorkerCompensation(policy?.is_type)"
              class="text-neutral-1100 text-xs font-medium"
            >
              {{ calculateLimit(policy?.limit || null) }}
              {{ calculateCurrency(policy?.insurance_certificate?.currency) }}
            </span>
            <span
              v-else
              class="text-neutral-1100 text-xs font-medium"
            >
              {{ hasStatutoryLimit(policy) ? 'Statutory' : 'Other' }}
            </span>
          </div>
          <section
            v-if="
              policy.is_type === 'umbrella_liability' ||
              policy.is_type === 'excess_liability' ||
              policy.is_type === 'commercial_general_liability'
            "
            class="flex w-full flex-col justify-between gap-2"
          >
            <div class="flex w-[200px] flex-col gap-0.5">
              <span class="text-xs font-medium text-steel-800">
                Each Ocurrence
              </span>
              <span class="text-neutral-1100 text-xs font-medium">
                {{
                  Math.abs(eachOcurrenceLimit(policy)?.value) > 0
                    ? calculateLimit(Math.abs(eachOcurrenceLimit(policy).value))
                    : '-'
                }}
              </span>
            </div>
            <span class="border-b border-steel-200"></span>

            <div class="flex w-full flex-col gap-0.5">
              <span class="text-xs font-medium text-steel-800">
                General Aggregate
              </span>
              <span class="text-neutral-1100 text-xs font-medium">
                {{
                  Math.abs(aggregateLimit(policy)?.value) > 0
                    ? calculateLimit(Math.abs(aggregateLimit(policy).value))
                    : '-'
                }}
              </span>
            </div>
          </section>
          <section
            v-if="policy.is_type === 'employers_liability'"
            class="flex flex-col gap-2"
          >
            <div class="flex w-full justify-between">
              <div class="flex w-[200px] flex-col">
                <span class="text-xs font-medium text-steel-800">
                  E.L. Each Accident
                </span>
                <span class="text-neutral-1100 text-xs font-medium">
                  {{
                    Math.abs(elEachAccidentLimit(policy)?.value) > 0
                      ? calculateLimit(
                          Math.abs(elEachAccidentLimit(policy).value)
                        )
                      : '-'
                  }}
                </span>
              </div>
              <span class="mx-4 my-1 border-l border-steel-200"></span>
              <div class="flex w-full flex-col gap-0.5">
                <span class="text-xs font-medium text-steel-800">
                  E.L. Disease - EA Employee
                </span>
                <span class="text-neutral-1100 text-xs font-medium">
                  {{
                    Math.abs(elDiseaseEachEmployeeLimit(policy)?.value) > 0
                      ? calculateLimit(
                          Math.abs(elDiseaseEachEmployeeLimit(policy).value)
                        )
                      : '-'
                  }}
                </span>
              </div>
            </div>
            <span class="border-b border-steel-200"></span>

            <div class="flex flex-col gap-0.5">
              <span class="text-xs font-medium text-steel-800">
                E.L. Disease - Limit
              </span>
              <span class="text-neutral-1100 text-xs font-medium">
                {{
                  Math.abs(elDiseaseLimit(policy)?.value) > 0
                    ? calculateLimit(Math.abs(elDiseaseLimit(policy).value))
                    : '-'
                }}
              </span>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div
      v-if="!excludeForCarrierRepresentative"
      class="justify-self-end px-4 pb-4"
    >
      <ButtonComponent
        variant="default"
        :use-base-class="false"
        class="flex h-[40px] w-full items-center justify-center rounded-md"
        @click="
          showCertificateAsPDF(
            policy?.insurance_certificate?.certificate_image?.url
          )
        "
      >
        <p class="text-sm font-medium text-steel-900">View Certificate</p>
      </ButtonComponent>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import ButtonComponent from '@/components/ButtonComponent.vue';
import Popper from 'vue3-popper';

export default {
  components: { ButtonComponent, Popper },
  name: 'InsuranceCard',
  props: {
    policy: {
      type: Object,
      required: true,
    },
    increaseTheHeight: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      insurance_types: {
        commercial_general_liability: 'General Liability',
        automobile_liability: 'Auto',
        motor_truck_cargo: 'Cargo',
        workers_compensation: "Workers' Compensation",
        trailer_interchange: 'Trailer Interchange',
        contingent_auto: 'Contingent Auto',
        contingent_cargo: 'Contingent Cargo',
        umbrella_liability: 'Umbrella Liability',
        excess_liability: 'Excess Liability',
        employers_liability: 'Employers Liability',

        // refrigeration_breakdown: "Reefer Breakdown", // TODO: We are ignoring refrigeration_breakdown for now. We are currently only showing the types for Auto and Cargo.
      },
    };
  },
  computed: {
    displayConnectedInsurance() {
      return (
        this.$store.state.users.featureFlags
          ?.display_carrier_connected_insurance?.enabled &&
        this.policy?.connected_insurer
      );
    },
    getPolicyStyle() {
      const status = this.policy?.status;
      const style = {
        backgroundColor: '',
        fontColor: '',
      };

      if (status === 'inactive') {
        style.backgroundColor = 'bg-rose-700';
        style.fontColor = 'text-white';
      } else if (status === 'active') {
        style.backgroundColor = 'bg-forest-500';
        style.fontColor = 'text-white';
      } else if (status === 'pending_cancellation') {
        style.backgroundColor = 'bg-pumpkin-700';
        style.fontColor = 'text-white';
      } else {
        style.backgroundColor = 'bg-steel-200';
        style.fontColor = 'text-steel-700';
      }
      return style;
    },
    getActiveInDays() {
      const today = new Date();
      const effectiveDate = new Date(this.policy?.effective_date);

      const millisecondsInADay = 1000 * 60 * 60 * 24;
      const differenceInMilliseconds = effectiveDate - today;
      const daysUntilActive = Math.ceil(
        differenceInMilliseconds / millisecondsInADay
      );

      if (daysUntilActive > 0) {
        return `Active in ${daysUntilActive} Days`;
      }
      return '';
    },
    excludeForCarrierRepresentative() {
      return this.$store.state.users.currentUser?.scopes?.includes(
        'carrier_representative'
      );
    },
    displayAdditionalInsuredBadge() {
      return (
        this.$store.state.users.featureFlags?.enable_additional_insured_badge
          ?.enabled || false
      );
    },
    isExpirationWithin7Days() {
      const today = new Date();
      const expiration = new Date(this.policy?.expiration_date);
      const timeDiff = expiration.getTime() - today.getTime();
      const diffInDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      if (diffInDays <= 7 && this.policy.status === 'active') {
        // If expiration is within 7 days and status is active, put the date in red font
        return true;
      } else {
        return false;
      }
    },
    subheading() {
      if (!this.policy?.is_type) return '';

      if (this.policy?.scheduled_autos) {
        return 'scheduled autos';
      }
      if (this.policy?.is_refrigeration_breakdown_included) {
        return 'includes reefer breakdown';
      }

      return '';
    },
    displayAMBestRating() {
      const { currentUser, featureFlags } = this.$store.state.users || {};
      return (
        featureFlags?.display_am_best_rating?.enabled &&
        currentUser?.scopes?.includes('manage_users')
      );
    },
  },
  methods: {
    getPolicyStatus(status) {
      if (status === 'inactive') {
        return 'Cancelled';
      } else if (status === 'active') {
        return 'Active';
      } else if (status === 'pending_cancellation') {
        return 'Pending Cancellation';
      }
      return this.getActiveInDays;
    },
    formatTitleCase(string) {
      const normalizedString = this.nullTextify(string);
      if (normalizedString === 'N/A') return 'N/A';

      return normalizedString
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    elEachAccidentLimit(policy) {
      return policy?.insurance_limits?.find(
        (limit) => limit?.is_type === 'el_each_accident'
      );
    },
    elDiseaseEachEmployeeLimit(policy) {
      return policy?.insurance_limits?.find(
        (limit) => limit?.is_type === 'el_disease_each_employee'
      );
    },
    elDiseaseLimit(policy) {
      return policy?.insurance_limits?.find(
        (limit) => limit?.is_type === 'disease_policy_limit'
      );
    },
    eachOcurrenceLimit(policy) {
      return policy?.insurance_limits?.find(
        (limit) => limit?.is_type === 'each_occurrence'
      );
    },
    aggregateLimit(policy) {
      if (
        policy.is_type === 'umbrella_liability' ||
        policy.is_type === 'excess_liability'
      ) {
        return policy?.insurance_limits?.find(
          (limit) => limit?.is_type === 'aggregate'
        );
      }

      return policy?.insurance_limits?.find(
        (limit) => limit?.is_type === 'general_aggregate'
      );
    },

    formatPolicy(number) {
      const policy = this.nullTextify(number);

      if (policy?.length > 30) {
        return `${policy.slice(0, 28)}...`;
      }

      return policy;
    },
    isWorkerCompensation(policyType) {
      return policyType === 'workers_compensation';
    },
    hasStatutoryLimit({ statutory_limits }) {
      return !!statutory_limits;
    },
    displayDate: function (initialDate) {
      if (initialDate == null) {
        return initialDate;
      } else {
        return moment(initialDate, 'YYYY-MM-DD').format('M/D/YY');
      }
    },
    nullTextify: function (value, nullVal = 'N/A') {
      if (value == null) {
        return nullVal;
      } else {
        return value;
      }
    },
    calculateLimit(limit) {
      if (limit) {
        return '$' + Math.round(limit)?.toLocaleString();
      } else {
        return '-';
      }
    },
    calculateExpirationDate(expiration) {
      if (expiration) {
        return moment(expiration).format('M/D/YY');
      } else {
        return '';
      }
    },
    calculateCurrency(currency) {
      if (currency !== 'usd') {
        return currency?.toUpperCase();
      } else {
        return '';
      }
    },
    showCertificateAsPDF(url) {
      window.open(url);
    },
  },
};
</script>
<style scoped>
.card-shadow {
  box-shadow: 0 5px 10px 0 rgba(109, 113, 129, 0.14);
}
</style>
